import { Component } from '@angular/core';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Component({
  selector: 'app-tams-index',
  templateUrl: './tams-index.component.html',
  styleUrls: ['./tams-index.component.scss']
})
export class TamsIndexComponent {

  TipoUsuario = TipoUsuario;

  constructor(private authService: AuthService) { }

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }

}
